import { SinglePlayResponse } from '../../services/responseTypes/singlePlayResponse';
import { DynamicObject } from '../commonTypes';

export const getContentLiteDataFromSinglePlayData = (
  singlePlayB2bData: SinglePlayResponse | DynamicObject
) => {
  if (!singlePlayB2bData?.showDetails) {
    return {
      ...singlePlayB2bData?.assetDetails,
      showDetails: singlePlayB2bData?.assetDetails?.show_details
    };
  }
  return {
    ...singlePlayB2bData?.assetDetails,
    episodeNumber: singlePlayB2bData?.assetDetails.orderid,
    asset_subtype: singlePlayB2bData?.showDetails.asset_subtype,
    actors: singlePlayB2bData?.showDetails?.actors,
    directors: singlePlayB2bData?.showDetails?.directors,
    extended: singlePlayB2bData?.showDetails?.extended,
    showDetails: singlePlayB2bData?.showDetails
  };
};
